import { render, staticRenderFns } from "./the-number-of-statistics.vue?vue&type=template&id=79b0967c&scoped=true&"
import script from "./the-number-of-statistics.vue?vue&type=script&lang=ts&"
export * from "./the-number-of-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./the-number-of-statistics.vue?vue&type=style&index=0&id=79b0967c&prod&scoped=true&lang=scss&"
import style1 from "./the-number-of-statistics.vue?vue&type=style&index=1&id=79b0967c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0967c",
  null
  
)

export default component.exports